import React, { useState } from "react";
import { accountDetails } from "@di";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import LogoutContent from "@frameworks/web/components/header/HeaderDesk/RevampHeader/LogoutContent";
import LogOutContentBottom from "@frameworks/web/components/header/HeaderDesk/RevampHeader/LogOutContentBottom";
export const LoginLogoutDropdown = (props) => {
    let [phoneNumber, setPhoneNumber] = useState();
    const navigate = useNavigate();
    const logout = () => {
        localStorage.removeItem("acc_data");
        localStorage.removeItem("jwt_token");
        localStorage.removeItem("user_id");
        localStorage.removeItem("lgnSrc");
        localStorage.removeItem("guest_acc_data");
        sessionStorage.clear();
        navigate("");
        window.location.reload();
    };
    React.useEffect(() => {
        accountDetails.getAccPhoneNo().then((x) => setPhoneNumber(x));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: ` ${DeviceContext().isDesktop
                ? "logout-popup-drop login-dropdown support-content-drp desk-logout-section"
                : "logout-popup-block-mob"}` },
            React.createElement(Row, { className: "mx-0" },
                React.createElement(Col, { lg: 12, className: "grid-1 px-0" },
                    props.userType === ILoginFlows.CLIENT && (React.createElement(React.Fragment, null,
                        React.createElement(LogoutContent, { userName: props.userName }))),
                    props.userType === ILoginFlows.GUEST && (React.createElement(React.Fragment, null,
                        React.createElement(LogoutContent, { userName: props.userName })))),
                React.createElement(LogOutContentBottom, null)))));
};
